import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DegradationPathwayDialogResult } from './components/degradation-pathway-dialog-content/degradation-pathway-dialog-content.interface';
import { DialogType } from './dialog.interface';

@Component({
  selector: 'dialog-component',
  templateUrl: './dialog.component.html',
})
export class DialogComponent {

  @Input() header: string;
  @Input() params: any;
  @Input() type: DialogType;

  @Output() onCloseDialog = new EventEmitter<any>();

  private returnValue: any;
  private hasChanges: boolean = false;

  public onDegradationPathwayBlur(result: DegradationPathwayDialogResult): void{
    this.returnValue = result.url;
    this.hasChanges = result.hasChanges;
  }

  public onClose(): void {
    if (this.hasChanges)
      this.params.value = this.returnValue;
    this.params.hasChanges = this.hasChanges;
    this.onCloseDialog.emit(this.params);
  }

}


